<template>
  <b-modal
    v-model="_state"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    @show="initForm"
  >
    <template v-slot:modal-title>
      <h5 class="mb-0 text-secondary">
        {{ $t("page.condominium.createUser") }}
      </h5>
    </template>
    <template v-slot:default>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <b-form>
          <b-row class="no-gutters ml-n3">
            <b-col class="col-12 col-md-6 pl-3">
              <form-input
                v-model="user.name"
                label="requiredField.name"
                veeName="name"
                :veeRules="{ required: true }"
              />
            </b-col>
            <b-col class="col-12 col-md-6 pl-3">
              <form-input
                v-model="user.surname"
                label="requiredField.surname"
                veeName="surname"
                :veeRules="{ required: true }"
              />
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-4 pl-3">
              <form-input
                v-model="user.email"
                label="Email*"
                veeName="email"
                veeRules="required|email"
                @input="user.email = user.email.toLowerCase()"
              />
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-4 pl-3">
              <form-input v-model="user.telephone" label="telephone" />
            </b-col>
            <b-col class="col-12 col-lg-4 pl-3">
              <form-input
                v-if="$is1Board"
                v-model="user.role"
                label="requiredField.roleInCondominium"
                veeName="roleInCondominium"
                :veeRules="{ required: true }"
              />
              <form-select
                v-else
                v-model="user.role"
                label="requiredField.roleInCondominium"
                veeName="roleInCondominium"
                :veeRules="{ required: true, select: true }"
              >
                <b-form-select-option
                  v-for="(role, index) in userRoleOptions"
                  :key="index"
                  :value="role"
                >
                  {{ $is1Board ? role : $t(`userRoles.${role}`) }}
                </b-form-select-option>
              </form-select>
            </b-col>
            <div class="w-100 ml-3 my-4" />
            <b-col class="col-12 col-md-6 pl-3">
              <form-input v-model="user.address" label="address" />
            </b-col>
            <b-col class="col-12 col-md-6 pl-3">
              <form-input v-model="user.city" label="city" />
            </b-col>
            <b-col class="col-12 col-md-6 pl-3">
              <form-input v-model="user.province" label="province" />
            </b-col>
            <b-col class="col-12 col-md-6 pl-3">
              <form-input v-model="user.zip" label="cap" />
            </b-col>
            <b-col class="col-12 col-md-6 pl-3" v-if="user._id">
              <div>
                <strong>Groups</strong>
                <div>{{ user.group ? "In Group" : "-" }}</div>
              </div>
            </b-col>
            <b-col class="col-12 pl-3 switch-col">
              <base-switcher
                v-if="$is1Board"
                v-model="user.supplierEditting"
                name="contactInsertion"
                switchLabel="page.condominium.contact-insertion"
                sync
              />
              <base-switcher
                v-if="$is1Board"
                v-model="user.eventCreation"
                name="eventCreation"
                switchLabel="page.condominium.event-creation"
                sync
              />
            </b-col>
            <b-col class="col-5 pl-3 pt-3" v-if="!$isDomi">
              <strong>{{ $t("page.groups.associatedGroups") }}</strong>
              <group-management
                v-if="state"
                ref="groups"
                new
                :userId="user._id"
              />
            </b-col>
          </b-row>
        </b-form>
        <hr class="my-3 mx-n3" />
        <b-row class="no-gutters justify-content-end">
          <b-button
            variant="outline-dark"
            class="mr-1"
            @click="setModalState(false)"
          >
            {{ $t("button.cancel") }}
          </b-button>
          <b-button
            class="text-white"
            variant="primary"
            :disabled="invalid"
            @click="createUser"
          >
            {{ $t("button.send") }}
          </b-button>
        </b-row>
      </validation-observer>
      <!-- <div v-else-if="tab === 'groups'">
        <group-management :userId="user._id" @close="setModalState(false)" />
      </div> -->
    </template>
  </b-modal>
</template>

<script>
import { appMixin } from "./../../mixins";

import FormInput from "../Base/BaseFormInput";
import FormSelect from "../Base/BaseFormSelect";
import BaseSwitcher from "./../Base/Switcher.vue";
import GroupManagement from "../Groups/UserGroupManagement.vue";
export default {
  components: {
    FormInput,
    FormSelect,
    BaseSwitcher,
    GroupManagement
  },
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  mixins: [appMixin],
  data() {
    return {
      user: {},
      userRoleOptions: ["doorman", "director", "owner", "tenant"]
    };
  },
  computed: {
    _state: {
      get() {
        return this.state;
      },
      set(value) {
        this.setModalState(value);
      }
    },
    currentCondominium() {
      return this.$store.getters["condominium/getCurrentCondominium"];
    }
  },
  methods: {
    initForm() {
      this.user = {
        name: "",
        surname: "",
        email: "",
        telephone: "",
        address: "",
        city: "",
        province: "",
        zip: "",
        role: "",
        supplierEditting: false,
        eventCreation: false
      };
    },
    async createUser() {
      try {
        this.$store.commit("loader/SET_LOADER", {});

        const newUser = await this.$store.dispatch("user/createUser", {
          userInfo: this.getProfilePayload()
        });
        this.user._id = newUser._id;
        if (this.user.role)
          await this.$store.dispatch("user/addUserCondominium", {
            userId: newUser.id,
            condominiumId: this.currentCondominium._id,
            payload: {
              role: this.user.role
            }
          });

        await this.$store.dispatch("condominium/retrieveCondominiumUsers");
        await this.$store.dispatch(
          "condominium/retrieveCondominium",
          this.currentCondominium._id
        );
        await this.$refs.groups?.saveChanges(newUser.id);
        this.setModalState(false);
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("loader/RESET");
      }
    },
    getProfilePayload() {
      const data = {
        name: this.user.name,
        surname: this.user.surname,
        email: this.user.email,
        telephone: this.user.telephone,
        address: this.user.address,
        city: this.user.city,
        province: this.user.province,
        zip: this.user.zip,
        type: "guest"
      };
      if (this.$is1Board) {
        data.supplierEditting = this.user.supplierEditting;
        data.eventCreation = this.user.eventCreation;
      }
      if (this.user.email) data.type = "consumer";

      return data;
    },
    setModalState(value) {
      this.$emit("update:state", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.switch-col {
  /deep/ .d-flex {
    width: 100%;
    max-width: 310px;
    justify-content: space-between;
  }
}
</style>
